<template>
  <span>
    <img draggable="false" class="clickable" id="quit_btn_top" @click="goToChineesStart()" src="./../../assets/images/Asset 58.png" alt="">
    <img draggable="false" class="background_image" src="./../../assets/images/chinees/Asset 7.png" alt="">
    <img draggable="false" id="obj__1" src="./../../assets/images/chinees/Asset 5.png" alt="">
    <img draggable="false" id="obj__2" src="./../../assets/images/chinees/Asset 4.png" alt="">

    <span id="chinees_start_text_horo">Chinese sterrenbeeld</span>
    <span v-show="month > 0" id="chinees_intro_text_horo">Jouw Chinese sterrenbeeld is:</span>
    <span v-show="month > 0" v-html="months[month]" id="chinees_intro_text_horo_2"></span>
  </span>
</template>

<script>
// Puzzle code
// https://www.w3schools.com/howto/tryit.asp?filename=tryhow_css_flip_card

import swal from 'sweetalert2'

export default {
  name: "ChineesHoro",
  mounted() {
    this.horoInput()
  },

  created() {},
  destroyed() {},

  data() {
    return {
      months: [
        'Rat',
        'Os',
        'Tijger',
        'Konijn',
        'Draak',
        'Slang',
        'Paard',
        'Geit',
        'Aap',
        'Haan',
        'Hond',
        'Varken'
      ],
      month: null
    };
  },

  methods: {
    goToChineesStart() {
      this.$router.push('/chinees/start');
    },
    showMonth() {
      var month_elem = parseInt(document.getElementById('month').value)
      console.log(month_elem);

      if ( isNaN(month_elem) ) {
        this.horoInput();
      } else {
        this.month = ( (parseInt(month_elem) % 12) - 1 );
      }
    },
    horoInput() {
      var that = this
      new swal({
          allowEscapeKey: false,
          allowOutsideClick: false,
          title: "",
          html: `<span><p class='swal_html'>Wat is jou geboorte jaar?</p><input placeholder="1900 - 2099" id="month" type='number' min="1900" max="2099" style='border: 2px solid #739033; border-radius: 4px;' /></span>`,
          type: "success",
          showCancelButton: false,
          cancelButtonColor: '#d33',
          cancelButtonText: 'Nee, ga door',
          confirmButtonColor: "#9BCB3C",
          confirmButtonText: "Ga door",
        }).then(function (confirm) {
          if ( confirm.isConfirmed ) {
            that.showMonth();
          } else {
            // that.goToChineesHoro();
          }
        });
    }
  },

  computed: {},
  watch: {}
};
</script>

<style>
  #chinees_start_text_horo {
    font-family: 'LuckiestGuy';
    position: absolute;
    margin-top: 3%;
    width: 50%;
    left: 25%;
    color: #cb1916;
    font-size: 4vw;
    text-align: center;
  }
  #chinees_intro_text_horo {
    font-family: 'LuckiestGuy';
    position: absolute;
    margin-top: 13%;
    width: 50%;
    left: 25%;
    color: #422818;
    font-size: 3vw;
    text-align: center;
  }
  #chinees_intro_text_horo_2 {
    font-family: 'LuckiestGuy';
    position: absolute;
    margin-top: 20%;
    width: 50%;
    left: 25%;
    color: #422818;
    font-size: 6vw;
    text-align: center;
  }
</style>


